import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { authServices } from "../APIServices/UserData/authServices";
import { useNavigate } from "react-router-dom";

const Login = ({ email, setEmail }) => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [usePassword, setUsePassword] = useState("");

  const checkRegistrationSetup = async () => {
    setLoader(true)
    let userData = {}
    userData.email = email
    let data = await authServices.checkRegistrationSetup(userData)
    if (data?.statusCode === 200) {
      setUsePassword(data?.usePassword)
      setName(data?.name)
      setEmail(data?.email)
      if (data?.status !== "startLogin") {
        navigate("/signup");
      }
    }
    setLoader(false)
  }

  const login = async () => {
    setLoader(true)
    let userData = {}
    userData.email = email
    userData.password = password
    await authServices.login(userData)
    setLoader(false)
  }

  const goToSignUp = () => {
    navigate("/signup");
  };

  const goToForgotPassword = () => {
    navigate("/forget-password");
  };

  function getTwoInitials() {
    if (!name) return "";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }
    const first = parts[0][0];
    const last = parts[parts.length - 1][0];
    return (first + last).toUpperCase();
  }
  return (
    <Container fluid className="auth-layout">
      <Row className="full-height">
        <Col md={6} className="auth-side d-none d-md-flex align-items-center">
          <div className="auth-content">
            <h1>Work faster with TeamChat</h1>
            <p className="opacity-75">
              All your conversations, files and tools in one place.
            </p>
          </div>
        </Col>

        <Col md={6} className="flex-center">
          <div className="card-box">
            <h3 className="heading-lg text-center mb-4">
              Sign in to your WorkBridge
            </h3>
            {usePassword &&
              <Form.Group className="mb-3">
                <div className="hstack gap-2 mb-3">
                  <h6 className={`bg-primary-subtle p-3 rounded-1 fw-bold m-0`}>
                    {getTwoInitials(name)}
                  </h6>
                  <div>
                    <h6 className="m-0">{name}</h6>
                    <p className="small m-0 text-muted">{email}</p>
                  </div>
                </div>
              </Form.Group>
            }
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  disabled={usePassword}
                  placeholder="name@example.com"
                  className="form-input"
                />
              </Form.Group>
              {usePassword &&
                <Form.Group className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <div className="position-relative">
                    <Form.Control
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      className="form-input"
                    />
                    <button
                      type="button"
                      className="btn-icon-show"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "#999",
                      }}
                    >
                      {showPassword ? <FiEyeOff /> : <FiEye />}
                    </button>
                  </div>
                </Form.Group>
              }
              {usePassword ?
                <Button
                  onClick={login}
                  disabled={!email || !password || loader}
                  className="w-100 btn-primary-custom"
                >Sign In
                </Button>
                :
                <Button
                  onClick={checkRegistrationSetup}
                  disabled={loader || !email}
                  className="w-100 btn-primary-custom"
                >Continue
                </Button>
              }
            </Form>

            <p className="text-center text-muted-sm mt-3 m-0">
              Don’t have an account?{" "}
              <a onClick={goToSignUp}>
                <span className="link-primary">Create one</span>
              </a>
            </p>
            <p className="text-center text-muted-sm mt-1">
              or Forget Password?{" "}
              <a onClick={goToForgotPassword}>
                <span className="link-primary">Click here</span>
              </a>
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
